<template>
  <div class="wrapper">
    <div class="bg-page" :style="bgPage"></div>
    <div class="panel">
      <div class="body-panel-login">
        <b-form>
          <img
            class="img-fluid mx-auto d-block"
            src="@/assets/logo-indecx.png"
            alt=""
          />

          <div class="senhaAcesso px-3 pt-2 mb-2">
            <p>
              {{ $t('menu.settings.users.labels.twoFactorText') }}
              <strong>{{ hideEmail }}</strong>
            </p>
          </div>
          <b-form-group>
            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
              <b-input-group-text slot="prepend">
                <i
                  class="fas fa-unlock"
                  v-if="form.code === null || form.code === ''"
                ></i>
                <i class="fas fa-lock" v-else></i>
              </b-input-group-text>
              <b-input
                id="code"
                v-model="form.code"
                type="text"
                required
                :placeholder="$t('validateCode.form.codeInput')"
                autofocus
              ></b-input>
            </b-input-group>
          </b-form-group>
          <b-form-group>
            <b-button
              type="button"
              @click="validateData()"
              class="btn-block"
              variant="primary"
              :disabled="loading"
              >{{ $t('validateCode.form.submitButton') }}</b-button
            >
          </b-form-group>
        </b-form>

        <div class="px-3 pt-2 mb-2 text-center">
          <b-button
            type="button"
            @click="sendSMS()"
            class="btn-block"
            variant="link"
            :disabled="loadingSMS"
            >Não recebi! Enviar por SMS</b-button
          >
          <p>{{ smsReturn }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '../../../../services/api';
import backgroundImage1 from '../../../../assets/1.png';
import backgroundImage2 from '../../../../assets/2.png';
import backgroundImage3 from '../../../../assets/3.png';
import backgroundImage4 from '../../../../assets/4.png';
import backgroundImage5 from '../../../../assets/5.png';
import backgroundImage6 from '../../../../assets/6.png';
import backgroundImage7 from '../../../../assets/7.png';

export default {
  name: 'TwoFactor',
  props: {
    email: null,
    companyId: null,
  },
  data: () => ({
    hideEmail: '',
    smsReturn: '',
    show: true,
    loading: false,
    loadingSMS: false,
    form: {
      code: null,
    },
    bgPage: {
      background: null,
      backgroundRepeat: null,
      backgroundSize: null,
      backgroundPosition: null,
    },
    securityToken: null,
    securityCookie: null,
  }),
  computed: {
    ...mapState('authentication', ['user']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('users', ['user_data']),
  },
  methods: {
    async sendSMS() {
      this.loadingSMS = true;
      this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

      const phone = this.userAuth.celPhone;

      if (phone) {
        try {
          await api.post('/send-twofactor-sms', {
            celPhone: phone,
            email: this.userAuth.email,
          });

          this.smsReturn = `Código enviado para: * * * * * * * * ${phone.slice(
            phone.length - 3,
          )}`;
        } catch (error) {
          this.makeToast(
            this.$t('validateCode.tooltips.codeValidation.description'),
            this.$t('validateCode.tooltips.codeValidation.title'),
          );
        }
      } else {
        this.makeToast(
          'Nenhum número de celular encontrado.',
          this.$t('validateCode.tooltips.codeValidation.title'),
        );
      }

      this.loadingSMS = false;
    },
    async validateData() {
      this.loading = true;

      if (!this.form.code) {
        this.makeToast(
          this.$t('validateCode.tooltips.codeValidation.description'),
          this.$t('validateCode.tooltips.codeValidation.title'),
        );
      } else {
        try {
          await api.post(`${process.env.API_ROOT}/validate-two-factor-code`, {
            code: this.form.code,
          });

          // this.$router.push(`/change-password?code=${this.form.code}`);
          this.$router.push(`/dashboard/${this.companyId}`);
          this.calendarDates.selected = 'Últimos 30 dias';
        } catch (error) {
          this.makeToast(error.response.data.message, 'Oops!');
          setTimeout(() => {
            if (error.response.status === 411) {
              this.$router.push('/');
            }
          }, 1000);
        }
      }

      this.loading = false;
    },
    makeToast(message, title, append = false) {
      this.toastCount += 1;
      this.$bvToast.toast(`${message}`, {
        title,
        autoHideDelay: 5000,
        appendToast: append,
        variant: 'danger',
      });
    },
  },
  mounted() {
    const dividerEmail = this.email.split('@');
    this.hideEmail = `${this.email.substring(0, 2)}********@${dividerEmail[1]}`;
    const imgs = [
      backgroundImage1,
      backgroundImage2,
      backgroundImage3,
      backgroundImage4,
      backgroundImage5,
      backgroundImage6,
      backgroundImage7,
    ];
    this.bgPage.background = `url('${imgs[Math.floor(Math.random() * 7)]}')`;
    this.bgPage.minHeight = '100vh';
    this.bgPage.minWidth = '100vw';
    this.bgPage.backgroundRepeat = 'no-repeat';
    this.bgPage.backgroundSize = 'cover';
    this.bgPage.backgroundAttachment = 'fixed';
    this.bgPage.backgroundPosition = 'center';
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/mixins.scss';
.recover-password {
  text-align: center;
  font-size: 0.9em;
}
.wrapper {
  @extend %center;
  .bg-page {
    width: auto;
    height: auto;
    min-width: 100%;
    min-height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    transform: scale(1);
    opacity: 0.6;
    z-index: -1;
    transition: all 0.2s linear;
    animation: zoomOut 0.4s;
  }
  @keyframes zoomOut {
    from {
      transform: scale(1.3);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 0.6;
    }
  }
  .panel {
    width: 90%;
    max-width: 420px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    @include bg-color(rgba(255, 255, 255, 0.8));
    @media screen and (min-width: 576px) {
      width: 100%;
    }
    .body-panel-login {
      @extend %double-padding-left,
        %double-padding-right,
        %double-padding-top,
        %double-padding-bottom;
      form {
        @extend %double-padding-top, %double-padding-bottom;
        .img-fluid {
          width: 50%;
          margin-bottom: 30px;
        }
        .input-group-text {
          border: none;
          @include bg-color($white);
          border-top-left-radius: 30px;
          border-bottom-left-radius: 30px;
          color: $secondary;
          border: 1px solid $gray-lighter;
          border-right: none;
        }
        .form-control {
          box-shadow: none;
          border: none;
          border-top-right-radius: 30px;
          border-bottom-right-radius: 30px;
          @include bg-color($white);
          text-indent: 0;
          padding: 0;
          color: $secondary;
          border: 1px solid $gray-lighter;
          border-left: none;
        }
      }
      button {
        border-radius: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home/authentication/two-factor.vue